import { render } from "./doctorInformation.vue?vue&type=template&id=6edc2b21"
import script from "./doctorInformation.vue?vue&type=script&lang=js"
export * from "./doctorInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__